import { Link } from "shared/components/Link";
import image from "../images/small-robot.png";
import './NotFound.scss'
export const NotFoundContent = () => {
    return <div className="container">
        <div className="p-3">

            <h2 className="not-found__title">404</h2>
            <p className="not-found__description">Страница не найдена</p>
            <div className="d-flex flex-column">
                <div className="d-flex justify-content-center" style={{ height: '300px' }}>
                    <img src={image} className="h-100 " alt="грустный робот" />
                </div>


                <div className="d-flex justify-content-center" >
                    <Link to={'/'}>
                        <button
                            className="accent-button button-hover"
                            type="button"
                            aria-label="вернуться назад"
                        >
                            На главную
                        </button>
                    </Link>
                </div>

            </div>
        </div>
    </div>
}